module.exports = __webpack_public_path__ + "img/footer_service.ccbd97c2.png";